import AccountingActive from "../assets/svg/iconSidebar/active-Accounting.svg";
import BankingActive from "../assets/svg/iconSidebar/Active-Banking.svg";
import chequeActive from "../assets/svg/iconSidebar/active-cheque.svg";
import TransactionActive from "../assets/svg/iconSidebar/active-transaction.svg";
import ReportsActive from "../assets/svg/iconSidebar/active-Reports.svg";
import FilemanagerActive from "../assets/svg/iconSidebar/FilemanagerActive.svg";
export const quickAccessConstant = [
  {
    img: TransactionActive,
    name: "ثبت فاکتور",
    shortName: "ثبت فاکتور",
    url: "/factors/add",
  },
  {
    img: BankingActive,
    name: "ثبت انتقال",
    shortName: "ثبت انتقال",
    url: "/transfers/add",
  },
  {
    img: chequeActive,
    name: "چک های دریافتی",
    shortName: "چک دریافتی",
    url: "/cheques/receive",
  },
  {
    img: AccountingActive,
    name: "ثبت سند حسابداری",
    shortName: "ثبت سند",
    url: "/accounting/add",
  },
  {
    img: ReportsActive,
    name: "گزارشات",
    shortName: " گزارش",
    url: "/reports",
  },
];
